"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListRow = void 0;
var React = require("react");
var components_1 = require("components");
var FileIcon_1 = require("components/FileIcon");
var useCustomMeta_1 = require("../hook/useCustomMeta");
var ListRow = function (section) {
    return React.memo(function (_a) {
        var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
        var isMobile = data.isMobile, items = data.items, columns = data.columns, baseUrl = data.baseUrl, itemSelections = data.itemSelections, toggleItem = data.toggleItem, token = data.token;
        var file = items[index];
        var selected = itemSelections[file.uuid];
        var renderCustomMeta = (0, useCustomMeta_1.useCustomMeta)(columns, file, baseUrl, isMobile, token, section);
        return (React.createElement("div", { className: className + ' ' + (file.type !== 'FOLDER' ? 'file' : ''), style: style },
            React.createElement("div", { className: "row__column first narrow icon" },
                React.createElement("div", { className: 'file-icon' }, (0, FileIcon_1.typeToIconAndTextMap)(file.type).icon),
                React.createElement(components_1.TableRowIcon, { icon: 'fa-check', circle: true, className: selected ? 'selected' : null, onClick: function (e) {
                        e.stopPropagation();
                        toggleItem(file);
                    } })),
            renderCustomMeta));
    }, function (nextProps, props) {
        if (nextProps.data !== props.data) {
            return false;
        }
        return true;
    });
};
exports.ListRow = ListRow;
